var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-pay-off-chart"},[_c('v-stock-chart',{ref:"payoffChart",staticClass:"chart",attrs:{"options":_vm.chartOptions,"api":_vm.chart,"theme":"dark","height":140}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }